'use client'

import * as React from 'react'
import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
} from 'next-themes'

const ForceLightThemeContext = React.createContext<((forced: boolean) => void) | null>(
  null
)

export function ThemeProvider({ children, forcedTheme, ...props }: ThemeProviderProps) {
  const [lightForced, setLightForced] = React.useState(false)

  return (
    <NextThemesProvider
      {...props}
      forcedTheme={lightForced ? 'light' : forcedTheme}
    >
      <ForceLightThemeContext.Provider value={setLightForced}>
        {children}
      </ForceLightThemeContext.Provider>
    </NextThemesProvider>
  )
}

/** Visually lock light mode without writing the user's stored theme. */
export function ForceLightTheme() {
  const setLightForced = React.useContext(ForceLightThemeContext)

  React.useEffect(() => {
    if (!setLightForced) return
    setLightForced(true)
    return () => setLightForced(false)
  }, [setLightForced])

  return null
}
